


export const getModifiedData = (data) => {
  
  data.Grades.sort((a, b) => a.Predmet.localeCompare(b.Predmet))

  const grades = data.Grades.reduce((acc, item) => {
    const {Parallel, idorganization, Predmet} = item
    if (!acc.has(Parallel)) acc.set(Parallel, new Map())
    const byPredmet = acc.get(Parallel)
    if (!byPredmet.has(Predmet)) byPredmet.set(Predmet, new Map())
    byPredmet.get(Predmet).set(idorganization, item)
    return acc
  }, new Map())

  const counts = data.Counts.reduce((acc, item) => {
    const { kurs, idorganization } = item
    if (!acc.has(kurs)) acc.set(kurs, new Map())
    acc.get(kurs).set(idorganization, item)
    return acc
  }, new Map())
  
  console.log(grades, counts)

  return {grades, counts}
}